import React, { useEffect, useState } from 'react';
import { adminApi } from '../../api/client';
import { Trash2, Loader2, Mail } from 'lucide-react';

export default function ManageContacts() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { setItems(await adminApi.list('contacts')); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm('Silməyə əminsiniz?')) return;
    await adminApi.remove('contacts', id);
    load();
  };

  const fmt = (iso) => {
    try { return new Date(iso).toLocaleString('az-AZ'); } catch { return iso; }
  };

  return (
    <div>
      <h2 style={{ fontSize: 22, fontWeight: 700, margin: '0 0 20px' }}>Müraciətlər</h2>
      {loading ? (
        <div style={{ padding: 40, textAlign: 'center' }}><Loader2 className="spin" size={22} /></div>
      ) : items.length === 0 ? (
        <div style={{ background: '#fff', padding: 40, textAlign: 'center', color: '#6b7280', borderRadius: 10, border: '1px solid #e5e7eb' }}>
          <Mail size={32} style={{ margin: '0 auto 8px', display: 'block', opacity: 0.4 }} />
          Hələ müraciət yoxdur
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {items.map((c) => (
            <div key={c.id} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 18 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15 }}>{c.name} {c.surname} {c.fatherName}</div>
                  <div style={{ fontSize: 12, color: '#6b7280' }}>{fmt(c.createdAt)}</div>
                </div>
                <button onClick={() => remove(c.id)} style={{ background: 'transparent', border: '1px solid #fecaca', borderRadius: 6, padding: 6, cursor: 'pointer', color: '#dc2626' }}>
                  <Trash2 size={14} />
                </button>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '8px 16px', fontSize: 13, color: '#374151' }}>
                {c.phone && <div><b>Telefon:</b> {c.phone}</div>}
                {c.city && <div><b>Şəhər:</b> {c.city}</div>}
                {c.birth && <div><b>Doğum tarixi:</b> {c.birth}</div>}
                {c.specialty && <div><b>İxtisas:</b> {c.specialty}</div>}
                {c.workplace && <div><b>İş yeri:</b> {c.workplace}</div>}
                {c.position && <div><b>Vəzifə:</b> {c.position}</div>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
